import axios, { AxiosRequestConfig } from 'axios';
import { UserClient } from './users';
import { PostsClient } from './posts';
import { GroupClient } from './groups';
import { UploadsClient } from './uploads';
import { CommentsClient } from './comments';
import ky from 'ky';

const http_client = ky.create({
  prefixUrl: '/api',
  timeout: false,
  hooks: {
    afterResponse: [
      (_req, _opts, res) => {
        if (res.status === 401) {
          // this should only happen if not logged in. Redirect to the login page!
          // todo: is this the best way to do this?
          // todo: should we clear the store here?
          window.location.assign('/signin');
        }
      },
    ],
  },
});

class PeepClient {
  users: UserClient;
  posts: PostsClient;
  groups: GroupClient;
  uploads: UploadsClient;
  comments: CommentsClient;

  constructor() {
    this.users = new UserClient(http_client);
    this.posts = new PostsClient(http_client);
    this.groups = new GroupClient(http_client);
    this.uploads = new UploadsClient();
    this.comments = new CommentsClient(http_client);
  }
}

export const peep_client = new PeepClient();
